import React from 'react'
import { FormattedMessage } from 'react-intl'
import error from '../../assets/images/error.png'

function ErrorBoundary({ message }) {
  return (
    <div style={{ height: window.innerHeight }} className="w-full items-center justify-center flex flex-col">
      <img src={error} className={'max-w-[300px] w-full'} alt="" />
      <p className='mt-4 text-xl'>
        {message || (
          <FormattedMessage
            id="error.boundary.generic"
            defaultMessage="Something went wrong. Please try again later."
          />
        )}
      </p>
    </div>
  )
}

export default ErrorBoundary